"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizeOverrides = void 0;
exports.sizeOverrides = [
    {
        props: { size: 'XS' },
        style: {
            borderRadius: '0.125rem',
            padding: '0.375rem 0.75rem',
            fontSize: '1rem',
            lineHeight: '1.25rem',
            minHeight: '2rem',
        },
    },
    {
        props: { size: 'S' },
        style: {
            borderRadius: '0.125rem',
            padding: '0.625rem 1.25rem',
            fontSize: '1rem',
            lineHeight: '1.25rem',
            minHeight: '2.5rem',
        },
    },
    {
        props: { size: 'M' },
        style: {
            borderRadius: '0.125rem',
            padding: '1rem 1.5rem',
            fontSize: '1rem',
            lineHeight: '1.25rem',
            minHeight: '3.25rem',
        },
    },
    {
        props: { size: 'L' },
        style: {
            borderRadius: '0.125rem',
            padding: '1.375rem 1.75rem',
            fontSize: '1rem',
            lineHeight: '1.25rem',
            minHeight: '4rem',
        },
    },
    {
        props: { size: 'XS', variant: 'tertiaryDefault' },
        style: {
            borderRadius: '0.125rem',
            padding: '0.375rem 0.5rem',
            fontSize: '1rem',
            lineHeight: '1.25rem',
            minHeight: '2rem',
        },
    },
    {
        props: { size: 'XS', variant: 'tertiaryHC' },
        style: {
            borderRadius: '0.125rem',
            padding: '0.375rem 0.5rem',
            fontSize: '1rem',
            lineHeight: '1.25rem',
            minHeight: '2rem',
        },
    },
    {
        props: { size: 'S', variant: 'tertiaryDefault' },
        style: {
            borderRadius: '0.125rem',
            padding: '0.625rem 0.5rem',
            fontSize: '1rem',
            lineHeight: '1.25rem',
            minHeight: '2.5rem',
        },
    },
    {
        props: { size: 'S', variant: 'tertiaryHC' },
        style: {
            borderRadius: '0.125rem',
            padding: '0.625rem 0.5rem',
            fontSize: '1rem',
            lineHeight: '1.25rem',
            minHeight: '2.5rem',
        },
    },
    {
        props: { size: 'M', variant: 'tertiaryDefault' },
        style: {
            borderRadius: '0.125rem',
            padding: '1rem 0.5rem',
            fontSize: '1rem',
            lineHeight: '1.25rem',
            minHeight: '3.25rem',
        },
    },
    {
        props: { size: 'M', variant: 'tertiaryHC' },
        style: {
            borderRadius: '0.125rem',
            padding: '1rem 0.5rem',
            fontSize: '1rem',
            lineHeight: '1.25rem',
            minHeight: '3.25rem',
        },
    },
    {
        props: { size: 'L', variant: 'tertiaryDefault' },
        style: {
            borderRadius: '0.125rem',
            padding: '1.375rem 0.5rem',
            fontSize: '1rem',
            lineHeight: '1.25rem',
            minHeight: '4rem',
        },
    },
    {
        props: { size: 'L', variant: 'tertiaryHC' },
        style: {
            borderRadius: '0.125rem',
            padding: '1.375rem 0.5rem',
            fontSize: '1rem',
            lineHeight: '1.25rem',
            minHeight: '4rem',
        },
    },
];
